import { createFileRoute } from '@tanstack/react-router';
import { useIntegrations, useUserRole } from '../../../../api/query';
import { IntegrationPageView } from '../../../../pages';

const DEFAULT_INTEGRATIONS_DATA = { integrations: [], integrationsMetadata: undefined };

const IntegrationPage = () => {
  const { integration, authenticatedUserEmail } = Route.useLoaderData();
  const { data, isFetching, isLoading, isError, isLoadingError } = useIntegrations();
  const { data: userAccessRole } = useUserRole(authenticatedUserEmail);

  const { integrations, integrationsMetadata } = data?.data ?? DEFAULT_INTEGRATIONS_DATA;
  const userRole = userAccessRole?.data?.role;

  return (
    <IntegrationPageView
      integrations={integrations}
      integrationsMetadata={integrationsMetadata}
      currentIntegration={integration}
      userRole={userRole}
      isLoading={isFetching || isLoading}
      isError={isError || isLoadingError}
    />
  );
};

export const Route = createFileRoute('/_auth/integration/$integration')({
  component: IntegrationPage,
  loader: ({ params, context }) => {
    return { integration: params.integration, authenticatedUserEmail: context.user?.username };
  },
});
